import { StatusEnum } from "./status-enum";

export const statusLabels = {
  [StatusEnum.DELIVERED]: "Dikirim",
  [StatusEnum.PARTIALLY_INVOICED]: "Difaktur Sebagian",
  [StatusEnum.FULLY_INVOICED]: "Difaktur",
};
